import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"; // Corrected BrowserRouter usage
import Header from "./compnents/layout/Header.js";
import Footer from "./compnents/layout/Footer.js";
import Home from "./pages/Home";
import Courses from "./pages/Courses.js";
import Login from "./compnents/Login";
import SignUp from "./compnents/SignUp";
import Confirm from "./compnents/ConfirmEmail";
import ResetPassword from "./compnents/ResetPassword";
import ChangePassword from "./compnents/ChangePassword";
import SingleCourse from "./compnents/SingleCourse.js";
import HandleLogin from "./compnents/HandleLogin.js";
import ProtectedRoute from "./compnents/ProtectedRoute.js";
import MyLearning from "./compnents/MyLearning.js";
import MyLearningLessons from "./compnents/MyLearningLessons.js";
import ShowLessons from "./compnents/ShowLessons.js";
import AdminDashBoard from "./compnents/admin/AdminDashBoard.js";
import ProtectedAdmin from "./compnents/protectAdmin";
import Packages from "./compnents/Packages.js";
import FinalTest from "./compnents/FinalTest.js";
import Certificate from "./compnents/Certificate.js";
import Contact from "./pages/Contact.js";
import Profile from "./pages/Profile.js";
import Article from "./pages/Article.js";
import Active from "./pages/Active.js";
import Users from "./pages/Users.js";
import UserProfile from "./pages/UserProfile.js";
import LearningPaths from "./pages/RoadMap.js";
import AICoursePath from "./pages/AiCoursePath.js";
import InstructorsPage from "./pages/Instructor.js";
import Projects from "./pages/projects.js";
import "./index.css";
import Terms from "./pages/Terms.js";
// if (!/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
// 	document.addEventListener('contextmenu', (event) => event.preventDefault());

// 	document.addEventListener('keydown', function (event) {
// 		if (event.code === 'F12') {
// 			event.preventDefault();
// 		}
// 		if (event.ctrlKey && event.shiftKey && event.code === 'KeyI') {
// 			event.preventDefault();
// 		}
// 		if (event.ctrlKey && event.shiftKey && event.code === 'KeyC') {
// 			event.preventDefault();
// 		}
// 		if (event.metaKey && event.shiftKey && event.code === 'KeyC') {
// 			event.preventDefault();
// 		}
// 		if (event.metaKey && event.altKey && event.code === 'KeyC') {
// 			event.preventDefault();
// 		}
// 	});
// }

function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <div className="font-rubik custom-scroll">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/login"
            element={
              <HandleLogin>
                <Login />
              </HandleLogin>
            }
          />
          <Route path="/courses" element={<Courses />} />
          <Route path="/courses/:id" element={<SingleCourse />} />
          <Route path="/my-learning/:id" element={<MyLearningLessons />} />
          <Route path="/my-learning/:id/:lessonId" element={<ShowLessons />} />
          <Route path="/my-learning/:id/final-test" element={<FinalTest />} />
          <Route
            path="/my-learning/:id/certificate"
            element={<Certificate />}
          />
          <Route
            path="/signup"
            element={
              <HandleLogin>
                <SignUp />
              </HandleLogin>
            }
          />
          <Route path="/confirm-email" element={<Confirm />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/password-change" element={<ChangePassword />} />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-learning/"
            element={
              <ProtectedRoute>
                <MyLearning />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/"
            element={
              <ProtectedAdmin>
                <AdminDashBoard />
              </ProtectedAdmin>
            }
          />
          <Route path="/packages" element={<Packages />} />
          <Route path="/article" element={<Article />} />
          <Route path="/projects" element={<Projects />} />

          <Route path="/active" element={<Active />} />
          <Route path="/users" element={<Users />} />
          <Route path="/roadMap" element={<LearningPaths />} />
          <Route path="/AICoursePath" element={<AICoursePath />} />
          <Route path="/InstructorsPage" element={<InstructorsPage />} />
          <Route path="/Terms" element={<Terms />} />
          <Route path="/users/:id" element={<UserProfile />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
